import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

export const fetchSettingData = createAsyncThunk(
    "setting/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const response = await request({
                endpoint: "/user/settings",
                method: "GET",
            });

            console.log("Fetch SettingData Response:", response);

            if (!response.success) {
                return rejectWithValue(response.message || "Failed to fetch Settings data.");
            }

            return response.data.settings;
        } catch (error) {
            console.error("Error fetching Settings data:", error);
            return rejectWithValue(error.message || "An unexpected error occurred while fetching Settings data.");
        }
    }
);

const initialState = {
    settings: null,
    loading: false,
    error: null,
};

const settingSlice = createSlice({
    name: 'setting',
    initialState,
    reducers: {
        addSettings: (state, action) => {
            state.settings = action.payload
        },
        addLabelSettings: (state, action) => {
            state.settings.labelSettings.config = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSettingData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSettingData.fulfilled, (state, action) => {
                state.loading = false;
                state.settings = action.payload;
            })
            .addCase(fetchSettingData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export const { addSettings, addLabelSettings } = settingSlice.actions;
export default settingSlice.reducer;